// src/stores/GlobalStore.ts
import { makeAutoObservable, autorun } from 'mobx'
import { createContext } from 'react'

export class GlobalStore {
  state: { [key: string]: any } = {}

  constructor() {
    makeAutoObservable(this)

    // Load the initial count from localStorage, if it exists
    const store = localStorage.getItem('globalStore')
    if (store) {
      const storeParsed = JSON.parse(store)
      this.state = storeParsed
    }

    // Automatically save to localStorage whenever count changes
    autorun(() => {
      localStorage.setItem('globalStore', JSON.stringify(this.state))
    })
  }

  setState(state: any) {
    this.state = state
  }
  getState() {
    return this.state
  }
}

export const globalStore = new GlobalStore()
export const GlobalStoreContext = createContext<GlobalStore | null>(null)
